import React from "react";

const About = () => {
  return (
    <div>
      <section className="section about-section">
        <h1 className="section-title">About</h1>
        <p>
        Welcome to our cocktail recipe website!

We are dedicated to bringing you the best and most delicious cocktail recipes from around the world. Our team of expert mixologists has carefully curated a collection of classic and modern cocktail recipes that are easy to make at home.

Whether you're looking for a refreshing summer cocktail, a cozy winter warmer, or a sophisticated cocktail to impress your guests, we've got you covered. From the classic Margarita to the trendy Aperol Spritz, our recipes are sure to tantalize your taste buds.

In addition to our cocktail recipes, we also provide tips and tricks for making the perfect cocktail, including how to properly muddle herbs, shake cocktails, and garnish your drinks like a pro.

So grab your shaker and let's get mixing! Cheers!
        </p>
      </section>
    </div>
  );
};

export default About;
